import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import {
  ANALYTCS_API_ROOT_URL,
  ApiModule,
  API_ROOT_URL,
  ArchModule,
  AuthModule,
  AUTH_MANAGER_TOKEN_NAME,
  AUTH_TOKEN_NAME,
  AUTO_CATCH_CONFIG,
  HttpErrorHandler,
  HttpErrorInterceptor,
  HttpErrorMessageHandler,
  InactiveEnterpriseErrorHandler,
  InterceptorConfig,
  LOGIN_ROUTE,
  MANAGER_API_ROOT_URL,
  SGV_ROOT_URL
} from '@eceos/arch';
import { AssetsModule } from '@eceos/assets';
import {
  COOKIE_NAME,
  CURRENCY_MASK_CONFIG,
  DefaultCurrencyMaskConfig
} from '@eceos/common-components';
import { DomainModule } from '@eceos/domain';
import { DefaultMatPaginatorIntl, FontAwesomeRegister } from '@eceos/shared-third-party';
import {
  faArchive,
  faArrowLeft,
  faBriefcase,
  faCalculator,
  faCalendarAlt,
  faCheck,
  faChevronRight,
  faCloudDownloadAlt,
  faEllipsisV,
  faFile,
  faFileExport,
  faFileImport,
  faFileSignature,
  faHandshake,
  faHandsHelping,
  faPeopleCarry,
  faPrint,
  faTractor,
  faTruck,
  faUserCircle,
  faUserTie,
  faBarcode
} from '@fortawesome/free-solid-svg-icons';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from '../../environments/environment';
import { MAIN_MENU } from '../features/features-catalog';

@NgModule({
  declarations: [],
  imports: [CommonModule, DomainModule, ApiModule, AuthModule, ArchModule, AssetsModule],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: DefaultCurrencyMaskConfig },
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-br' },
    { provide: AUTH_TOKEN_NAME, useValue: 'eceos.authToken' },
    { provide: AUTH_MANAGER_TOKEN_NAME, useValue: 'manager.authToken' },
    { provide: COOKIE_NAME, useValue: 'eceos.cookieConsent' },
    { provide: LOGIN_ROUTE, useValue: '/login' },
    { provide: API_ROOT_URL, useValue: environment.apiRoot },
    { provide: SGV_ROOT_URL, useValue: environment.sgvRoot },
    { provide: ANALYTCS_API_ROOT_URL, useValue: environment.analyticsApiRoot },
    { provide: MANAGER_API_ROOT_URL, useValue: environment.managerApiRoot },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'standard' }
    },
    { provide: MatPaginatorIntl, useClass: DefaultMatPaginatorIntl },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptchaV3Key },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: AUTO_CATCH_CONFIG, useValue: InterceptorConfig.INTERCEPT },
    { provide: HttpErrorHandler, useClass: HttpErrorMessageHandler, multi: true },
    { provide: HttpErrorHandler, useClass: InactiveEnterpriseErrorHandler, multi: true }
  ]
})
export class CoreModule {
  constructor(registry: FontAwesomeRegister) {
    registry.registerAll(...MAIN_MENU.icons);
    registry.registerAll(
      faArrowLeft,
      faCheck,
      faChevronRight,
      faUserCircle,
      faPrint,
      faFileImport,
      faFileExport,
      faTractor,
      faFile,
      faBriefcase,
      faCalendarAlt,
      faUserTie,
      faCalculator,
      faHandsHelping,
      faTruck,
      faPeopleCarry,
      faHandshake,
      faArchive,
      faCloudDownloadAlt,
      faEllipsisV,
      faFileSignature,
      faBarcode
    );
  }
}
